import { useMemo } from 'react';
import { useApplicationContext } from '../../ApplicationContext';
import { DEFAULT_SPECIFICATION } from './constants';
import * as React from 'react';
import { renderSpecification } from './utils/renderSpecification';
import { jsx as _jsx } from "react/jsx-runtime";
export var VillageAddingTopBannerContainer = function VillageAddingTopBannerContainer() {
  var _useApplicationContex = useApplicationContext(),
    config = _useApplicationContex.config;
  var banner = useMemo(function () {
    var specification = config.get('feedbackForm.villageAddingSpecification') || DEFAULT_SPECIFICATION;
    return renderSpecification(specification);
  }, [config]);
  return /*#__PURE__*/_jsx("div", {
    children: banner
  });
};